module.exports = __webpack_public_path__ + "img/logo.3bf2080c.3bf2080c.png";